// npm run dev
import './declarations';
import 'swiper/css';
import './sass/index.scss';
import NobuUIService from './services/nobu-ui.service';
import initTopbarComponent from './components/topbar.component';
import initPageHeaderComponent from './components/page-header.component';
import initSlideshowComponent from './components/slideshow.component';
import initSliderComponent from './components/slider.component';
import initCarouselComponent from './components/carousel.component';
import initStacksComponent from './components/stacks.component';
import initStickyComponent from './components/sticky.component';
import initTopTabsComponent from './components/top-tabs.component';
import initTabsComponent from './components/tabs.component';
import initPopupComponent from './components/popup.component';
import initSocialLinksCardComponent from './components/social-links-card.component';
import initCollapsibleComponent from './components/collapsible.component';
import initNobuVideosComponent from './components/nobu-videos.component';
import initVideoFrameComponent from './components/video-frame.component';
import initNewsletterFormComponent from './components/newsletter-form.component';
import initAppearOnScrollComponent from './components/appear-on-scroll.component';
import initFloatingButtonsComponent from './components/floating-buttons.component';
import initAppearAnimationsComponent from './components/appear-animations.component';
import initFormComponent from './components/form.component';
import initCardRestrictComponent from './components/card-restrict.component';

import customGlobalCode from './custom-global';

import homeHolderPage from './pages/home-holder-page';
import homeInquiriesPage from './pages/home-inquiries-page';
import restaurantTakeoutPage from './pages/restaurant-takeout-page';
import restaurantCareerPositionPage from './pages/restaurant-career-position-page';
import initLangButtonComponents from './components/lang-button.component';

import DebugService from './debug';
import restaurantEventsEnquiryPage from './pages/restaurant-events-enquiry-page';

document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

function onDOMContentLoaded() {
    initTopbarComponent();
    initPageHeaderComponent();
    initSlideshowComponent();
    initSliderComponent();
    initCarouselComponent();
    initStacksComponent();
    initStickyComponent();
    initTopTabsComponent();
    initTabsComponent();
    initPopupComponent();
    initSocialLinksCardComponent();
    initCollapsibleComponent();
    initNobuVideosComponent();
    initVideoFrameComponent();
    initNewsletterFormComponent();
    initAppearOnScrollComponent();
    initFloatingButtonsComponent();
    initAppearAnimationsComponent();
    initFormComponent();
    initCardRestrictComponent();
    initLangButtonComponents();

    NobuUIService
        .onPage("HomeHolder", homeHolderPage)
        .onPage("HomeInquiriesPage", homeInquiriesPage)
        .onPage("RestaurantTakeoutPage", restaurantTakeoutPage)
        .onPage("RestaurantCareerPositionPage", restaurantCareerPositionPage)
        .onPage("RestaurantEventsEnquiryPage", restaurantEventsEnquiryPage)

    customGlobalCode();

    if (process.env.NODE_ENV === "development") {
        if (process.env.DEBUG === "true") {
            DebugService({
                startTimeout: 2000,
                clearConsole: false,
                checkAria: true,
                checkFocus: true,
            });
        }
    }
}
